export default __webpack_public_path__ + "85f43627aa7f4f896250222be24c472a.jpg";